module.exports = __webpack_public_path__ + "img/vpn-8.03a9f8f7.jpg";